__turbopack_context__.v({
  "button": "BuyOnlineCta-module__IlPIqq__button",
  "buyOnlineCta": "BuyOnlineCta-module__IlPIqq__buyOnlineCta",
  "copy": "BuyOnlineCta-module__IlPIqq__copy",
  "or": "BuyOnlineCta-module__IlPIqq__or",
});
